import { Card, Text } from '@nike/eds';

export type Country = {
  code: string;
  label: string;
};

export type Address = {
  addressLine1: string;
  zipCode: string;
  city: string;
  region: string;
  country: Country;
};

export type ImporterOfRecord = {
  identifier: string;
  name: string;
  address: Address;
};

export function ImporterOfRecordDetails({ importer }: { importer: ImporterOfRecord }) {
  return (
    <Card padding={24} className="importer-details-card">
      <Text font={'title-5'} as={'h3'}>{importer.name}</Text>
      <Text font={'subtitle-2'} as={'div'} className='details-label'>Identifier</Text>
      <Text font={'body-2'} as={'div'}>{importer.identifier}</Text>
      <Text font={'subtitle-2'} as={'div'} className='details-label'>Address</Text>
      <Text font={'body-2'} as={'p'}>{importer.address.addressLine1}</Text>
      <Text font={'body-2'} as={'p'}>{importer.address.city}, {importer.address.region} {importer.address.zipCode}</Text>
      <Text font={'subtitle-2'} as={'div'} className='details-label'>Country</Text>
      <Text font={'body-2'} as={'div'}>
        {importer.address.country.label} ({importer.address.country.code})
      </Text>
    </Card>
  );
}